import DataTable, { Column } from "../../components/DataTable";

import TemplateActionDropdown from "./TemplateActionDropDown";
import { Invoice } from "../../types/feesAndPaymentType";
import { formatDateTime } from "../../util/functions/UniversalFunctions";

interface TemplatesListProps {
  data: Invoice[];
  onDelete: (invoiceId: number) => void;
  onView: (invoice: Invoice) => void;
}

export default function TemplatesList({
  data,
  onDelete,
  onView,
}: TemplatesListProps) {
  const columns: Column<Invoice>[] = [
    { label: "SL NO.", accessor: "invoiceId" },
    {
      label: "Template Name",
      accessor: "name",
      searchable: true,
      render: (item) => <div className="text-[13px]">{item.paymentTitle}</div>,
    },
    {
      label: "Total Amount(₹)",
      accessor: "totalAmount",
      render: (item) => (
        <div className="text-neutral-400 text-sm font-bold">
          ₹ {item.amount}
        </div>
      ),
    },
    {
      label: "Created On",
      accessor: "createdOn",
      render: (item) => (
        <div className="text-[13px]">
          {formatDateTime(item.createdAt) ?? "---"}
        </div>
      ),
    },
    {
      label: "Action",
      accessor: "action",
      render: (item) => (
        <TemplateActionDropdown
          onDelete={() => onDelete(item.invoiceId)}
          onView={() => onView(item)}
        />
      ),
    },
  ];
  return (
    <div className="bg-white px-6 py-5 rounded-lg overflow-x-auto">
      <DataTable columns={columns} data={data} />
    </div>
  );
}
